// @i18n-ignore-file
// Reads the `x-gctx-canary-group-id` cookie that ssr persists from the
// request header of the same name. Browser-only — returns null on the
// server (ssr-side outbound calls already get the header via explicit param
// threading through `getCommonHeaders`, `fetchSiteData`, etc.). The cookie
// key intentionally reuses the header constant as its name.

import { CANARY_GROUP_ID_HEADER } from '@src/constants/api.headers.constants'
import getCookie from '@src/quince-site-common/src/utils/getCookie'

export function getCanaryGroupId(): string | null {
  return getCookie(CANARY_GROUP_ID_HEADER) ?? null
}
